import React from 'react';

function ResultCount({ totalItems, page, itemsPerPage }) {
  let startOffset = (page * itemsPerPage) % totalItems;
  let endOffset = startOffset + itemsPerPage;
  if (endOffset > totalItems) {
    endOffset = totalItems;
  }
  if (totalItems === 0) {
    startOffset = 0;
    endOffset = 0;
  } else {
    startOffset += 1;
  }
  return (
    <div className='result-count'>
      <span> Showing </span>
      <strong> {startOffset}-{endOffset} </strong>
      <span> of </span>
      <strong> {totalItems} </strong>
      <span> results </span>
    </div>
  );
}

export default ResultCount;
